// Shared contract for cursor-paginated list endpoints (assignment history, key history, ...).
// nextCursor is omitted by the backend on the last page; hasMore is what decides whether
// paging continues, because a cursor may still be present on the last page.
export interface CursorPage<T> {
  data: T[];
  hasMore: boolean;
  nextCursor?: string;
}

export interface CursorPageParams {
  limit?: number;
  cursor?: string;
}

export const DEFAULT_CURSOR_PAGE_LIMIT = 20;

// getNextCursor returns the cursor for the following page, or undefined to stop paginating.
// Suitable as getNextPageParam for useInfiniteQuery.
export function getNextCursor<T>(page: CursorPage<T>): string | undefined {
  return page.hasMore ? page.nextCursor : undefined;
}

// flattenCursorPages joins every loaded page into one ordered list.
export function flattenCursorPages<T>(pages: CursorPage<T>[] | undefined): T[] {
  return (pages ?? []).flatMap((page) => page.data);
}
